import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';
import { formatPromoDate } from 'entities/Promo/lib/formatPromoDate';

const PROMO_SHEET_DATE_FORMAT = 'd MMMM';

export const getMobileAppPromoSheetTexts = (bonusAmount: number, startDate: string, endDate: string) => {
  const formattedStartDate = formatPromoDate(startDate, PROMO_SHEET_DATE_FORMAT);
  const formattedEndDate = formatPromoDate(endDate, PROMO_SHEET_DATE_FORMAT);

  return {
    title: `${bonusAmount}${UNBREAKABLE_SEPARATOR}₽ за первый займ в${UNBREAKABLE_SEPARATOR}приложении`,
    description: `Просто оформите займ в приложении Сравни с${UNBREAKABLE_SEPARATOR}${formattedStartDate} по${UNBREAKABLE_SEPARATOR}${formattedEndDate}, погасите его без просрочек — начислим вам ${bonusAmount}${UNBREAKABLE_SEPARATOR}₽`,
    info: `${bonusAmount}${UNBREAKABLE_SEPARATOR}₽ придут на бонусный счёт Сравни.`,
    info2: `Их можно вывести через СБП к себе на карту`,
    linkText: 'Полные условия акции',
    buttonText: 'Получить займ в приложении',
  };
};
